import { MapContainer, TileLayer, Marker, Polygon, Popup, useMap } from "react-leaflet";
// import { useMap } from "react-leaflet/hooks";
import MapLayers from "./MapLayers";
import L from "leaflet";

import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

function Component({ center, zoom, markers, polygons }) {

  center = center || [1.3521, 103.8198];
  zoom = zoom || 12;
  markers = markers || [];
  polygons = polygons || [];

  const markerRenders = markers.map(item => {
    const icon = new L.Icon({
      iconUrl: item.iconUrl,
      popupAnchor:  [-0, -0],
      iconSize: item.iconSize,
    });
    return (
      <Marker key={item.id} position={item.position} icon={icon}>
        <Popup>
          {item.popup}
        </Popup>
      </Marker>
    );
  });

  const polygonRenders = polygons.map(item => {
    return (
      <Polygon key={item.id} pathOptions={item.pathOptions} positions={item.positions}>
        <Popup>
          {item.popup}
        </Popup>
      </Polygon>
    )
  });

  return (
    <MapContainer className="w-100 h-100" center={center} zoom={zoom} scrollWheelZoom={true}>
      <MapLayers />
      {markerRenders}
      {polygonRenders}
    </MapContainer>
  );


}

export default Component;
